import React, { useState } from 'react'
import { message } from 'antd'
import { LookLgjDetail, InspirationTransfer } from 'component'
import { DeleteColl, Icon } from 'meinian-package/src/component'
import { QuickAccess } from 'baseComponent'
import { Dropdown } from 'meinian-package/src/baseComponent'
import { ExportAll, DownloadAll } from 'component/batch/options'
import { teamHasAuth, isPermissions } from 'meinian-package/src/utils/auth'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import { request } from 'meinian-package/src/utils'
import { IDEA_MASS_ROLE } from 'meinian-package/src/component/enum'
import { renderMoveImage } from 'meinian-package/src/component/useFunModal/moveImage'
import Share, { Sharing } from '../../../share'
import EditIdeaMass from '../../../editIdeaMass'
import { MoreBtn } from '../../action'
import styles from './index.module.less'

export default ({
  loginUserInfo = {},
  isQuickAccess,
  shareStatus: __shareStatus,
  id,
  name,
  onDelete,
  onChange,
  onClick,
  getPopupContainer
}) => {
  const auth = loginUserInfo?.inspirationPermissions || []
  const currentRole = loginUserInfo?.role
  const authExitCooperation = [IDEA_MASS_ROLE.AUDITOR, IDEA_MASS_ROLE.GATHER, IDEA_MASS_ROLE.VIEWER].includes(loginUserInfo.role)
  const [shareStatus, setShareStatus] = useState(__shareStatus)
  const [dropDownVisible, setDropDownVisible] = useState(false)
  const _onClick = () => {
    setDropDownVisible(false)
    onClick?.()
  }

  const _onChange = (...arg) => {
    onChange?.(...arg)
  }
  const _onDelete = (val) => {
    onDelete?.(val)
  }

  const onShare = (_shareStatus, e) => {
    e && e.stopPropagation()
    _shareStatus ? Sharing.show({ auth, inspirationId: id, name, onChange: setShareStatus })
      : Share.show({ auth, inspirationId: id, name, onChange: setShareStatus })
  }

  const onExitCooperation = (inspirationId, e) => {
    e.stopPropagation()
    ModalConfirm.show({
      title: '退出协作',
      content: '是否退出协作',
      onOk: async () => {
        request.get('/zhikuan/ins/inspiration/auth/sing-out-inspiration', { params: { inspirationId } }).then(success => {
          if (success) {
            message.success('退出协作成功')
            _onDelete({ id: inspirationId })
          }
        })
      }
    })
  }

  return <Dropdown
    open={dropDownVisible}
    onOpenChange={(vis) => { setDropDownVisible(vis) }}
    trigger="hover"
    getPopupContainer={getPopupContainer}
    placement="bottomRight"
    overlay={<div
      className={styles['more-operation-wrap']}
    >
      {auth.includes('F02') ? <LookLgjDetail
        inspirationId={id}
        onChange={_onChange}
        onDelete={_onDelete}
      >
        <div className="mn-dropdown-icon-li" onClick={_onClick}><Icon type="m-xiangqing" />灵感集详情</div>
      </LookLgjDetail> : null}
      { auth.includes('F03')
        ? <EditIdeaMass
            auth={auth}
            currentRole={currentRole}
            inspirationId={id}
            onChange={_onChange}
            onDelete={_onDelete}
        >
          <div className="mn-dropdown-icon-li" onClick={_onClick}><Icon type="m-bianji" />编辑</div>
        </EditIdeaMass> : null }
      {
        isPermissions(auth, ['FS04', 'FS04_CREATOR', 'FCS04', 'FCS04_CREATOR']) && <div
          className="mn-dropdown-icon-li"
          onClick={() => {
            renderMoveImage({
              fromInspirationIdList: [id],
              hasMove: false,
              onChange: () => {
                _onDelete({ id })
              }
            })
          }}
        ><Icon type="m-yidong" />移动全部款式</div>
      }
      {auth.includes('F06') ? <>
        <div className="li-partition" />
        <EditIdeaMass
          auth={auth}
          inspirationId={id}
          mode={2}
          onChange={_onChange}
        >
          <div className="mn-dropdown-icon-li" onClick={_onClick}><Icon type="m-xiezuochengyuan" />协作成员</div>
        </EditIdeaMass>
      </> : null}
      <div className="li-partition" />
      <QuickAccess
        isQuickAccess={isQuickAccess}
        id={id}
        name={name}
        onChange={_onChange}
      >
        <div className="mn-dropdown-icon-li" onClick={(e) => { e.preventDefault() }}><Icon type={isQuickAccess ? 'm-quxiaokuaisufangwen' : 'm-kuaisufangwen'} />{isQuickAccess ? '移除快速访问' : '快速访问'}</div>
      </QuickAccess>
      {auth.includes('F09') && teamHasAuth('meinian_share_inspiration') ? <div
        className="mn-dropdown-icon-li"
        onClick={(e) => {
          e.preventDefault()
          onShare(shareStatus, e)
        }}
      ><Icon type={shareStatus ? 'm-fenxiang' : 'm-fenxiang'} />{ shareStatus ? '分享中' : '分享' }</div> : null}
      {
            (teamHasAuth('meinian_download_all_blog') || teamHasAuth('meinian_export_all_blog')) && <div className="li-partition" />
          }
      {
          teamHasAuth('meinian_download_all_blog') && <DownloadAll inspirationId={id}>
            <div className="mn-dropdown-icon-li" onClick={_onClick}><Icon type="m-xiazai" />下载全部款式</div>
            </DownloadAll>
        }
      {
          teamHasAuth('meinian_export_all_blog') && <ExportAll inspirationId={id}>
            <div className="mn-dropdown-icon-li" onClick={_onClick}><Icon type="m-daochu" />导出全部款式</div>
          </ExportAll>
        }
      {
          authExitCooperation && <>
            <div className="li-partition" />
            <div className="mn-dropdown-icon-li" onClick={(e) => onExitCooperation(id, e)}><Icon type="m-tuichu" />退出协作</div>
          </>
        }
      {auth.includes('F15')
        ? <>
          <div className="li-partition" />
          <InspirationTransfer
            className="inspiration-transfer"
            inspirationId={id}
            onChange={_onDelete}
          >
            <div className="mn-dropdown-icon-li" onClick={_onClick}><Icon type="m-zhuanrang" />转让</div>
          </InspirationTransfer>
        </> : null}

      { auth.includes('F04')
        ? <>
          <div className="li-partition" />
          <div
            className="mn-dropdown-icon-li delete"
            onClick={(e) => {
              e.preventDefault()
              DeleteColl({ params: { inspirationId: id }, onDelete: () => _onDelete({ id }) })
              e.stopPropagation()
            }}
          ><Icon type="m-shanchu" />删除</div>
        </>
        : null}
    </div>}
  >
    <MoreBtn onClick={(e) => { e.preventDefault(); e.stopPropagation() }} />
  </Dropdown>
}
